import React, { Component } from 'react';
import { Tab, Button, Message, Container, Header, Icon } from 'semantic-ui-react';
import { getPaymentStatus } from '../../../common/utils';
import { Mentor, Competition, Team } from './Form';
//import { clone } from 'ramda';
import { withNamespaces } from 'react-i18next';
import { generate } from 'shortid';

class TeamTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTabIndex: 0
    };
  }
  
  render() {
    const {
      t,
      data,
      events,
      onEventUpdate,
      onCompetitionUpdate,
      onMentorUpdate,
      onMembersUpdate,
      onChange,
      onDelete,
      onTabChange
    } = this.props;

    const tc = data.technicalControl || {},
          status = tc.status || 'NA';

    const panes = [
      {
        menuItem: {
          key: generate(),
          icon: 'trophy',
          content: t('private:addTeam.steps.competition')
        },
        render: () =>
          <Tab.Pane>
            <Competition
              events={events}
              teamId={data.teamId}
              event={data.event}
              competition={data.competition}
              onEventUpdate={onEventUpdate}
              onCompetitionUpdate={onCompetitionUpdate}
            />
          </Tab.Pane>
      },
      {
        menuItem: {
          key: generate(),
          icon: 'graduation cap',
          content: t('private:addTeam.steps.mentor')
        },
        render: () =>
          <Tab.Pane>
            <Mentor
              data={data.mentor}
              onChange={onMentorUpdate}
            />
          </Tab.Pane>
      },
      {
        menuItem: {
          key: generate(),
          icon: 'users',
          content: t('private:addTeam.steps.team')
        },
        render: () =>
          data.competition && data.competition.id && 
          <Tab.Pane>
            <Team
              teamName={data.name}
              robotName={data.robotName}
              competitionCode={data.competition.code}
              robotNumber={data.robotNumber}
              robotRequired={data.competition.robotRequired}
              teamMemberLimit={data.competition.teamMemberLimit}
              members={data.members}
              data={data.mentor}
              onChange={onChange}
              onMembersChange={onMembersUpdate}
            />
          </Tab.Pane>
      }
    ];

    if (data.teamId) {
      panes.push({
        menuItem: {
          key: generate(),
          icon: 'flag checkered',
          content: t('private:addTeam.steps.technicalControl')
        },
        render: () =>
          <Tab.Pane>
            <Container fluid>
              <Header as='h5'>
                {tc.status === 'PASSED' && <Icon color='green' name='check' />}
                {tc.status === 'FAILED' && <Icon color='red' name='ban' />}
                {tc.status === 'NA' && <Icon color='grey' name='minus' />}
                {t('private:technicalControl.status.' + status )}
              </Header>
              <p>{tc.comments}</p>
            </Container>
          </Tab.Pane>
      });
    }

    if (getPaymentStatus(data) === 'NOT_PAID' && data.teamId) {
      panes.push({
        menuItem: {
          key: generate(),
          icon: 'delete',
          content: t('common:delete')
        },
        render: () =>
          <Tab.Pane>
            <Message
              icon='exclamation triangle'
              content={t('private:addTeam.delete.warning')}
            />
            <Message warning/>
            <Button
              negative
              content={t('private:addTeam.delete.button')}
              onClick={onDelete}
            />
          </Tab.Pane>
      });
    }

    return (
      <Tab
        panes={panes}
        renderActiveOnly={true}
        onTabChange={onTabChange} />
    );
  };
};

export default withNamespaces(['private', 'common'])(TeamTab);



// WEBPACK FOOTER //
// ./src/private/common/components/Team/Tab.js